"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-unused-expressions */
/* eslint-disable no-param-reassign */
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const deepmerge_1 = __importDefault(require("deepmerge"));
const next_utils_context_1 = require("@gerenciatd/next.utils.context");
const next_utils_constants_1 = require("@gerenciatd/next.utils.constants");
const next_adabyron_custo_get_by_name_1 = require("@gerenciatd/next.adabyron.custo.get-by-name");
const next_components_tagged_component_1 = __importDefault(require("@gerenciatd/next.components.tagged-component"));
class CustomizerComponent extends react_1.Component {
    constructor(props) {
        super(props);
        this.onCompleteHandler = (status, activityId) => {
            const { onComplete } = this.props;
            if (onComplete &&
                (status === next_utils_constants_1.NETWORK_STATUS.ERROR || status === next_utils_constants_1.NETWORK_STATUS.SUCCESS)) {
                onComplete({ activityId });
            }
        };
        this.searchForCreativitiesIds = (custoObj) => {
            const dotNotation = [];
            if (typeof custoObj === 'object') {
                Object.keys(custoObj).forEach((internalCustoObj) => {
                    if (internalCustoObj === 'taggingInfo') {
                        return;
                    }
                    const dotNotationRoot = `${internalCustoObj}`;
                    const dotNotationArray = this.searchForCreativitiesIds(custoObj[internalCustoObj]);
                    const dotNotationFinalArray = [];
                    let dotNotationString = '';
                    dotNotationArray.forEach((notation) => {
                        dotNotationString = `${dotNotationRoot}.${notation.key}`;
                        dotNotationFinalArray.push(Object.assign(Object.assign({}, notation), { key: dotNotationString }));
                    });
                    if (dotNotationFinalArray.length > 0) {
                        dotNotation.push(...dotNotationFinalArray);
                    }
                    else if (dotNotationRoot === 'creaName') {
                        dotNotation.push({
                            key: dotNotationRoot,
                            value: custoObj[dotNotationRoot],
                        });
                    }
                });
            }
            return dotNotation;
        };
        // TEMPORAL FIX TO DELETE REPEATED ELEMENTS ON ARRAYS POST DEEPMERGE EXECUTION
        // TODO change
        this.applyTransform2ObjectRecursivity = (input) => {
            const isAnObject = input && typeof input === 'object' && !(input instanceof RegExp);
            const myInput = isAnObject ? input : {};
            const keys = Object.keys(myInput);
            const res = isAnObject ? {} : input;
            keys.forEach((key) => {
                let currentValue = myInput[key];
                const currentValueType = typeof currentValue;
                if (currentValue &&
                    currentValue.$$typeof &&
                    currentValue.$$typeof.toString() === 'Symbol(react.element)') {
                    res[key] = currentValue;
                }
                else if (currentValueType === 'object' &&
                    !Array.isArray(currentValue)) {
                    res[key] = this.applyTransform2ObjectRecursivity(currentValue);
                }
                else if (currentValueType === 'object' && Array.isArray(currentValue)) {
                    currentValue = currentValue.filter((v, i, a) => a.findIndex((t) => JSON.stringify(t) === JSON.stringify(v)) === i);
                    res[key] = currentValue.map((arrayItem) => {
                        return this.applyTransform2ObjectRecursivity(arrayItem);
                    });
                }
                else {
                    res[key] = currentValue;
                }
            });
            return res;
        };
        this.requestDataForActivity = (icParams, activityId) => {
            const { context } = icParams;
            this.setState({ status: next_utils_constants_1.NETWORK_STATUS.FETCHING });
            (0, next_adabyron_custo_get_by_name_1.getByName)({
                name: activityId,
                icParams,
                build: false,
                context,
            })
                .then((response) => {
                if (response && response.error) {
                    debugger;
                    this.setState({ status: next_utils_constants_1.NETWORK_STATUS.ERROR });
                    this.onCompleteHandler(next_utils_constants_1.NETWORK_STATUS.ERROR, activityId);
                }
                else {
                    this.custoData.dotNotationToBuild =
                        this.searchForCreativitiesIds(response);
                    const newComponentData = (0, deepmerge_1.default)(response, this.custoData.componentData);
                    this.custoData.componentData =
                        this.applyTransform2ObjectRecursivity(newComponentData);
                    this.custoData.creasToResolve =
                        this.custoData.dotNotationToBuild.length;
                    this.custoData.dotNotationToBuild.forEach((dotNotationObj) => {
                        this.requestDataForCreativity(icParams, dotNotationObj.value, dotNotationObj.key);
                    });
                    if (this.custoData.dotNotationToBuild &&
                        this.custoData.dotNotationToBuild.length === 0) {
                        this.setState({
                            componentData: this.custoData.componentData,
                            status: next_utils_constants_1.NETWORK_STATUS.SUCCESS,
                        });
                        this.onCompleteHandler(next_utils_constants_1.NETWORK_STATUS.SUCCESS, activityId);
                    }
                }
            })
                .catch((e) => {
                debugger;
                console.log(`Customizer: ${e}`);
                this.setState({ status: next_utils_constants_1.NETWORK_STATUS.ERROR });
                this.onCompleteHandler(next_utils_constants_1.NETWORK_STATUS.ERROR, activityId);
            });
        };
        this.updateObjProp = (obj, value, propPath) => {
            const [head, ...rest] = propPath.split('.');
            !rest.length
                ? (obj[head] = value)
                : this.updateObjProp(obj[head], value, rest.join('.'));
        };
        this.requestDataForCreativity = (icParams, creativityId, dotNotationString) => {
            const { context } = icParams;
            (0, next_adabyron_custo_get_by_name_1.getByName)({
                icParams,
                context,
                build: false,
                name: creativityId,
                kind: 'creativity',
            })
                .then((response) => {
                if (response && response.error) {
                    this.setState({ status: next_utils_constants_1.NETWORK_STATUS.ERROR });
                    this.onCompleteHandler(next_utils_constants_1.NETWORK_STATUS.ERROR, creativityId);
                }
                else {
                    const dotNotationStringFinal = dotNotationString.replace('.creaName', '');
                    this.updateObjProp(this.custoData.componentData, response, dotNotationStringFinal);
                    this.custoData.creasToResolve -= 1;
                    if (this.custoData.creasToResolve === 0) {
                        this.setState({
                            componentData: this.custoData.componentData,
                            status: next_utils_constants_1.NETWORK_STATUS.SUCCESS,
                        });
                        this.onCompleteHandler(next_utils_constants_1.NETWORK_STATUS.SUCCESS, creativityId);
                    }
                }
            })
                .catch((e) => {
                debugger;
                console.log(`Customizer: ${e}`);
                this.setState({ status: next_utils_constants_1.NETWORK_STATUS.ERROR });
                this.onCompleteHandler(next_utils_constants_1.NETWORK_STATUS.ERROR, creativityId);
            });
        };
        const { customProps, dataMock } = props;
        this.custoData = {
            componentData: customProps,
            dotNotationToBuild: [],
            nestingLevel: 0,
            creasToResolve: 0,
        };
        this.state = {
            status: dataMock && dataMock.status,
            componentData: dataMock && dataMock.componentData,
        };
    }
    componentDidMount() {
        const { activityId, dataMock, component, onComplete, customProps } = this.props;
        if (!dataMock && component) {
            (0, next_utils_context_1.mapContextParamsToCustoReq)(`${activityId}`, (icParams) => {
                if ((icParams && icParams.i3Ready) ||
                    process.env.NODE_ENV !== 'production') {
                    this.requestDataForActivity(icParams, activityId);
                }
            });
        }
        if (dataMock && component) {
            const { status, componentData } = dataMock;
            this.setState({
                componentData: (0, deepmerge_1.default)(componentData, customProps),
                status,
            });
            if (onComplete &&
                (status === next_utils_constants_1.NETWORK_STATUS.ERROR || status === next_utils_constants_1.NETWORK_STATUS.SUCCESS)) {
                onComplete({ activityId });
            }
        }
    }
    render() {
        const { activityId, component: MyComponent, componentName, dataMock, } = this.props;
        const { status, componentData } = this.state;
        const id = componentName || activityId;
        let finalTaggingInfo = {};
        if (componentData && componentData.taggingInfo) {
            finalTaggingInfo = Object.assign({}, componentData.taggingInfo);
        }
        finalTaggingInfo.componentName = id;
        // Customizable component
        if (!dataMock) {
            return (react_1.default.createElement(next_components_tagged_component_1.default, { key: activityId, id: id, customizerId: activityId, WaitingComponent: (MyComponent && MyComponent.WaitingComponent) || (() => null), status: status, taggingInfo: finalTaggingInfo, visible: (componentData && componentData.visible) || true }, componentData && (react_1.default.createElement(MyComponent, Object.assign({}, componentData, { taggingInfo: Object.assign(Object.assign({}, componentData.taggingInfo), { componentName: finalTaggingInfo.componentName }) })))));
        }
        // Non Customizable component
        return (react_1.default.createElement("div", { className: "nonCustomizableComponent" }, componentData && (react_1.default.createElement(MyComponent, Object.assign({}, componentData, { taggingInfo: Object.assign(Object.assign({}, componentData.taggingInfo), { componentName: finalTaggingInfo.componentName }) })))));
    }
}
CustomizerComponent.propTypes = {
    activityId: prop_types_1.default.string.isRequired,
    componentName: prop_types_1.default.string,
    component: prop_types_1.default.oneOf([prop_types_1.default.node, prop_types_1.default.func]).isRequired,
    dataMock: prop_types_1.default.shape({
        status: prop_types_1.default.oneOf([
            next_utils_constants_1.NETWORK_STATUS.FETCHING,
            next_utils_constants_1.NETWORK_STATUS.SUCCESS,
            next_utils_constants_1.NETWORK_STATUS.ERROR,
        ]),
        component: prop_types_1.default.node,
        componentData: prop_types_1.default.object,
    }),
    onComplete: prop_types_1.default.func,
    /**
     * {
     *  "info": "Objeto con propiedades a enviar desde la aplicación,
     *  tienen mayor peso que las obtenidas desde customizer",
     *  "kind": "both",
     *  "beautifulName": "customProps"
     * }
     */
    customProps: prop_types_1.default.object,
};
CustomizerComponent.defaultProps = {
    dataMock: null,
    onComplete: null,
    customProps: {},
    componentName: null,
};
exports.default = CustomizerComponent;
//# sourceMappingURL=index.js.map